/* global axios */
import ApiClient from '../ApiClient';

class AidexacxTools extends ApiClient {
  constructor() {
    super('aidexacx/assistants/tools', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }
}

export default new AidexacxTools();
